import "./AssessChoice.scss";
import React from "react";
import { resultStore, assessStore } from "../stores";
import { observer } from "mobx-react";
import { Button } from "../lib";
import { Redirect } from "react-router-dom";
// import { Link } from 'react-router-dom'
import AssessDone from "./AssessDone";
import AssessChoiceCard from "./AssessChoiceCard";
import { ASSESS_TYPE_LEADER, ASSESS_TYPE_MEMBER } from "../constants";
import authStore from "../auth/auth-store";

const AssessChoice = () => {
  if (assessStore.retake) {
    return <Redirect to="/assess/leader" />;
  }
  if (resultStore.responses) {
    return <AssessDone />;
  }
  const progress = Math.round(assessStore.progress * 100);
  const isLeaderCompleted = assessStore.church;
  const isMemberStarted =
    assessStore.type === ASSESS_TYPE_MEMBER && progress > 0;
  const isLeaderStarted =
    assessStore.type === ASSESS_TYPE_LEADER && progress > 0;
  return (
    <div className="AssessChoice">
      <div className="AssessChoice_wrapper">
        <AssessChoiceCard
          to="assess/leader"
          className="AssessChoice_card_leader"
          prefix="Assess your church as a"
          title="Leadership Team"
          desc="Invite members of your staff and/or lay leader team to take the survey with you, and combine the whole group’s responses into one comprehensive report. This version is the most accurate, as it also asks you to input just a few objective metrics about your church, in addition to your team’s opinion data."
        >
          <Button styleType="primary">Leadership Assessment</Button>
          {isLeaderCompleted ? (
            <strong>Completed</strong>
          ) : isLeaderStarted ? (
            <strong>{progress}% complete</strong>
          ) : !authStore.auth ? (
            <strong>Login required</strong>
          ) : null}
        </AssessChoiceCard>
        <AssessChoiceCard
          to="/assess/member"
          className="AssessChoice_card_member"
          prefix="Assess your church as an"
          title="Individual"
          desc="Take the survey as an individual to determine where your church is in its life cycle. This survey’s results will be calcuated from the opinions you input."
        >
          <Button styleType="primary">Individual Assessment</Button>
          {isMemberStarted ? (
            <strong>{progress}% complete</strong>
          ) : !authStore.auth ? (
            <strong>No login required</strong>
          ) : null}
        </AssessChoiceCard>
      </div>
    </div>
  );
};

AssessChoice.displayName = "AssessChoice";

export default observer(AssessChoice);



// WEBPACK FOOTER //
// ./src/assess/AssessChoice.js